import { authHeader } from '../../../_helpers';
import axios from 'axios';

export const bulkDownloadPermissions = {
    addBulkDownloadPerm,
    removeBulkDownloadPerm,
    checkBulkDownloadPerm,
    downloadBulkReportService
    
};
axios.defaults.headers.common = authHeader();

function addBulkDownloadPerm(data) {
    return axios.post(`/assessments/organisation/report/bulk/download/add/permission/`, data)
        .then(response => {
            return response;
        });
}
function removeBulkDownloadPerm(data) {
    return axios.post(`/assessments/organisation/report/bulk/download/remove/permission/`, data)
        .then(response => {
            return response;
        });
}
function checkBulkDownloadPerm(data) {
    return axios.post(`/assessments/organisation/check/bulk_download/permission/`, data)
        .then(response => {
            return response;
        });
}
function downloadBulkReportService(data) {
    return axios.post(`/assessments/organisation/download/reports/`, data)
        .then(response => {
            return response;
        });
}


// WEBPACK FOOTER //
// ./src/_services/organisation/bulkDownload/index.js